import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AdminLayoutService {
    public menuItemsClosed: Subject<boolean> = new Subject();
}
